import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { destinoPedido, idsDoBooking } from '@/lib/destinoPedido';

// /booking (fluxo antigo de marcações) → /pedir (10/10/2026). Mantém os links e
// botões antigos a funcionar: com ?prestador= usa o link pessoal dele, com
// ?servico= começa o pedido com o nome do serviço.
const RedirecionarParaPedido: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let ativo = true;
    (async () => {
      const { prestador, servico } = idsDoBooking(location.search);
      let codigoPrestador: string | null = null;
      let tituloServico: string | null = null;
      try {
        const [p, s] = await Promise.all([
          prestador
            ? supabase.from('prestadores').select('codigo_indicacao').eq('id', prestador).maybeSingle()
            : Promise.resolve({ data: null }),
          servico
            ? supabase.from('servicos').select('titulo').eq('id', servico).maybeSingle()
            : Promise.resolve({ data: null }),
        ]);
        codigoPrestador = (p.data as { codigo_indicacao?: string | null } | null)?.codigo_indicacao ?? null;
        tituloServico = (s.data as { titulo?: string | null } | null)?.titulo ?? null;
      } catch {
        // sem dados extra: segue para o pedido em branco
      }
      if (ativo) navigate(destinoPedido({ codigoPrestador, tituloServico }), { replace: true });
    })();
    return () => { ativo = false; };
  }, [location.search, navigate]);

  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <p className="text-sm text-muted-foreground">A abrir o pedido…</p>
    </div>
  );
};

export default RedirecionarParaPedido;
